import React from 'react'
import classes from '@src/styles/PitchLeft.module.css'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { segmentTrack } from '@src/functions/segment'
import queryString from 'query-string'
import { withAttribution } from '@src/functions/attribution'
// import TrustBox from '../../../shared/components/TrustPilot'

const HeroText = () => (
  <h3 className={classes.heroText}>
    Start Growing
    <br /> Your Business
    <br /> Today
  </h3>
)

const SubText = ({ handleButtonClick }: { handleButtonClick: any }) => (
  <>
    <p className={classes.subText}>
      Dimension makes it simple for anyone with a hauling or dumpster rental business to connect to
      hundreds of jobs nearby, all with just the click of a button.
    </p>
    <div className={classes.buttonContainer}>
      <button className={classes.primaryButton} onClick={() => handleButtonClick('provider')}>
        Sign Up Now
      </button>
    </div>
  </>
)

function Pitch() {
  const history = useRouter()
  const handleButtonClick = (userType: string) => {
    // eslint-disable-next-line no-console
    console.log('handleButtonClick : userType', userType)
    // dispatch({ type: 'SET_TEMP_USER', userType })
    history.push(
      withAttribution(
        `${process.env.NEXT_PUBLIC_REDIRECT_URL}?`.concat(
          queryString.stringify({
            login: '1',
          }),
        ),
      ),
    )
    segmentTrack('User Clicks Register - Provider Portal', { userType })
  }
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.leftPane}>
          <div className={classes.pitchContent}>
            <HeroText />
            <SubText handleButtonClick={handleButtonClick} />
            {/* <TrustBox style='landing-widget' /> */}
          </div>
        </div>
        <div className={classNames(classes.rightPane, classes.providerPortal)} />
      </div>
    </div>
  )
}
export default Pitch
